var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentWrapper",attrs:{"id":"home"}},[(_vm.page && _vm.page.content)?_c('PageBuilder',{attrs:{"content":_vm.page.content}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }